"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _anchor = _interopRequireDefault(require("./anchor"));
var _entityLite = require("./entity-lite");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var buildLinkData = function buildLinkData(_ref) {
  var fields = _ref.fields;
  if (fields !== null && fields !== void 0 && fields.internalLink) {
    var entity = (0, _entityLite.createEntityLite)(fields.internalLink);
    var anchor = (0, _utils.getProp)(fields, 'anchorPoint') ? (0, _anchor["default"])(fields.anchorPoint) : null;
    var anchorSlug = anchor !== null && anchor !== void 0 && anchor.slug ? "#".concat(anchor.slug) : '';
    return {
      url: "".concat(entity.url).concat(anchorSlug),
      external: false
    };
  }
  if (fields !== null && fields !== void 0 && fields.externalLink) {
    return {
      url: (0, _utils.getProp)(fields, 'externalLink'),
      external: true
    };
  }
  return {
    url: null,
    external: false
  };
};

/**
 * Creates a `link` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.linkText
 * @param {string} entry.fields.linkStyle
 * @param {string} entry.fields.externalLink - a URL
 * @param {object} entry.fields.internalLink - a reference to a Contentful entry
 * @param {boolean} entry.fields.noFollow
 * @param {boolean} entry.fields.newTab
 * @returns {object} `link` content model
 */
var createLink = function createLink(_ref2) {
  var _sys$contentType;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  return _objectSpread(_objectSpread({
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    icon: (0, _utils.getProp)(fields, 'icon'),
    linkStyle: (0, _utils.getProp)(fields, 'linkStyle'),
    text: (0, _utils.getProp)(fields, 'linkText')
  }, buildLinkData({
    fields: fields
  })), {}, {
    noFollow: (0, _utils.getProp)(fields, 'noFollow'),
    newTab: (0, _utils.getProp)(fields, 'newTab'),
    fullWidth: (0, _utils.getProp)(fields, 'fullWidth')
  });
};
var _default = createLink;
exports["default"] = _default;